import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Utils from '../../providers/Utils';
import FinanciarFunctions from './FinanciarFunctions';
import InterpretareComponent1 from './InterpretareComponent1';
import RataRentabilitatiiEconomice from './RataRentabilitatiiEconomice';
import RataRentabilitatiiFinanciare from './RataRentabilitatiiFinanciare';
import TendintaRentabilitatiiEconomice from './TendintaRentabilitatiiEconomice';
import TendintaRentabilitatiiFinanciare from './TendintaRentabilitatiiFinanciare';


export default class AnalizaProfitPierdere extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    f = new FinanciarFunctions()
    u = new Utils()
    componentDidMount() {
    }


    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.analizaProfitPierdere} </h5>


                    <Divider className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid style={{ textAlign: 'left', marginTop: 20 }} container>
                        <Grid sm item>
                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.marjaComerciala}</span>
                        </Grid>

                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.marja}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>{this.u.formatNumber(this.f.getMarja(this.props.bilanturiDesc[0])) } Lei</span>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.trend}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>
                                        {this.f.getMarja(this.props.bilanturiDesc[0]) > this.f.getMarja(this.props.bilanturiDesc[1]) ? this.dictionary.financiar.crestere : this.dictionary.financiar.scadere}
                                        <i
                                            style={{
                                                marginLeft: 10,
                                                verticalAlign: 'middle',
                                                color: this.f.getMarja(this.props.bilanturiDesc[0]) > this.f.getMarja(this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                            }}
                                            className='material-icons'>{this.f.getMarja(this.props.bilanturiDesc[0]) > this.f.getMarja(this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>

                                    </span>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>

                    <Divider className='pm-divider' />

                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid style={{ textAlign: 'left', marginTop: 20 }} container>
                        <Grid sm item>
                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.productiaExercitiului}</span>
                        </Grid>

                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.valoare} {this.props.bilanturiDesc[0]['an']} </span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>{this.u.formatNumber(this.f.productiaExercitiului(this.props.bilanturiDesc[0])) } Lei</span>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.trend}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>
                                        {this.f.productiaExercitiului(this.props.bilanturiDesc[0]) > this.f.productiaExercitiului(this.props.bilanturiDesc[1]) ? this.dictionary.financiar.crestere : this.dictionary.financiar.scadere}
                                        <i
                                            style={{
                                                marginLeft: 10,
                                                verticalAlign: 'middle',
                                                color: this.f.productiaExercitiului(this.props.bilanturiDesc[0]) > this.f.productiaExercitiului(this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                            }}
                                            className='material-icons'>{this.f.productiaExercitiului(this.props.bilanturiDesc[0]) > this.f.productiaExercitiului(this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>

                                    </span>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid style={{ textAlign: 'left', marginTop: 20 }} container>
                        <Grid sm item>
                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.valoareAdaugata}</span>
                        </Grid>

                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.valoare} {this.props.bilanturiDesc[0]['an']} </span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>{this.u.formatNumber(this.f.valoareAdaugata(this.props.bilanturiDesc[0])) } Lei</span>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.trend}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>
                                        {this.f.valoareAdaugata(this.props.bilanturiDesc[0]) > this.f.valoareAdaugata(this.props.bilanturiDesc[1]) ? this.dictionary.financiar.crestere : this.dictionary.financiar.scadere}
                                        <i
                                            style={{
                                                marginLeft: 10,
                                                verticalAlign: 'middle',
                                                color: this.f.valoareAdaugata(this.props.bilanturiDesc[0]) > this.f.valoareAdaugata(this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                            }}
                                            className='material-icons'>{this.f.valoareAdaugata(this.props.bilanturiDesc[0]) > this.f.valoareAdaugata(this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>

                                    </span>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider className='pm-divider' />
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid style={{ textAlign: 'left', marginTop: 20 }} container>
                        <Grid sm item>
                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.excedentBrutDinExploatare}</span>
                        </Grid>

                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.valoare} {this.props.bilanturiDesc[0]['an']} </span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>{this.u.formatNumber( this.f.excedentBrutDinExploatare(this.props.bilanturiDesc[0]))} Lei</span>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.trend}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>
                                        {this.f.excedentBrutDinExploatare(this.props.bilanturiDesc[0]) > this.f.excedentBrutDinExploatare(this.props.bilanturiDesc[1]) ? this.dictionary.financiar.crestere : this.dictionary.financiar.scadere}
                                        <i
                                            style={{
                                                marginLeft: 10,
                                                verticalAlign: 'middle',
                                                color: this.f.excedentBrutDinExploatare(this.props.bilanturiDesc[0]) > this.f.excedentBrutDinExploatare(this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                            }}
                                            className='material-icons'>{this.f.excedentBrutDinExploatare(this.props.bilanturiDesc[0]) > this.f.excedentBrutDinExploatare(this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>

                                    </span>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider className='pm-divider' />
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid style={{ textAlign: 'left', marginTop: 20 }} container>
                        <Grid sm item>
                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.rezultatDinExploatare}</span>
                        </Grid>

                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.valoare} {this.props.bilanturiDesc[0]['an']} </span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>{this.u.formatNumber(this.f.rezultatDinExploatare(this.props.bilanturiDesc[0])) } Lei</span>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.trend}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>
                                        {this.f.rezultatDinExploatare(this.props.bilanturiDesc[0]) > this.f.rezultatDinExploatare(this.props.bilanturiDesc[1]) ? this.dictionary.financiar.crestere : this.dictionary.financiar.scadere}
                                        <i
                                            style={{
                                                marginLeft: 10,
                                                verticalAlign: 'middle',
                                                color: this.f.rezultatDinExploatare(this.props.bilanturiDesc[0]) > this.f.rezultatDinExploatare(this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                            }}
                                            className='material-icons'>{this.f.rezultatDinExploatare(this.props.bilanturiDesc[0]) > this.f.rezultatDinExploatare(this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>

                                    </span>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid style={{ textAlign: 'left', marginTop: 20 }} container>
                        <Grid sm item>
                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.rezultatulBrutAlExercitiului}</span>
                        </Grid>

                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.valoare} {this.props.bilanturiDesc[0]['an']} </span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>{this.u.formatNumber(this.f.rezultatulBrutAlExercitiului(this.props.bilanturiDesc[0])) } Lei</span>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.trend}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>
                                        {this.f.rezultatulBrutAlExercitiului(this.props.bilanturiDesc[0]) > this.f.rezultatulBrutAlExercitiului(this.props.bilanturiDesc[1]) ? this.dictionary.financiar.crestere : this.dictionary.financiar.scadere}
                                        <i
                                            style={{
                                                marginLeft: 10,
                                                verticalAlign: 'middle',
                                                color: this.f.rezultatulBrutAlExercitiului(this.props.bilanturiDesc[0]) > this.f.rezultatulBrutAlExercitiului(this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                            }}
                                            className='material-icons'>{this.f.rezultatulBrutAlExercitiului(this.props.bilanturiDesc[0]) > this.f.rezultatulBrutAlExercitiului(this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>

                                    </span>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider className='pm-divider' />
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid style={{ textAlign: 'left', marginTop: 20 }} container>
                        <Grid sm item>
                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.rezultatulNetAlExercitiului}</span>
                        </Grid>

                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.valoare} {this.props.bilanturiDesc[0]['an']} </span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>{this.u.formatNumber(this.f.rezultatulNetAlExercitiului(this.props.bilanturiDesc[0])) } Lei</span>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid sm item>
                            <Grid style={{ textAlign: 'left' }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b8b8b8' }}>{this.dictionary.financiar.trend}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: 'black' }}>
                                        {this.f.rezultatulNetAlExercitiului(this.props.bilanturiDesc[0]) > this.f.rezultatulNetAlExercitiului(this.props.bilanturiDesc[1]) ? this.dictionary.financiar.crestere : this.dictionary.financiar.scadere}
                                        <i
                                            style={{
                                                marginLeft: 10,
                                                verticalAlign: 'middle',
                                                color: this.f.rezultatulNetAlExercitiului(this.props.bilanturiDesc[0]) > this.f.rezultatulNetAlExercitiului(this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                            }}
                                            className='material-icons'>{this.f.rezultatulNetAlExercitiului(this.props.bilanturiDesc[0]) > this.f.rezultatulNetAlExercitiului(this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>

                                    </span>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider className='pm-divider' />
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <RataRentabilitatiiEconomice
                        bilanturiDesc={this.props.bilanturiDesc}
                    />


                </Grid>

                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span style={{ fontSize: 12 }}> {this.dictionary.financiar.rataRentabilitatiiEconomiceText}</span>

                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <TendintaRentabilitatiiEconomice
                        bilanturiDesc={this.props.bilanturiDesc}
                    />
                </Grid>

                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span style={{ fontSize: 12 }}> {this.dictionary.financiar.rataRentabilitatiiEconomiceText}</span>

                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <RataRentabilitatiiFinanciare
                        bilanturiDesc={this.props.bilanturiDesc}
                    />

                </Grid>

                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span style={{ fontSize: 12 }}> {this.dictionary.financiar.rataRentabilitatiiFinanciareText}</span>

                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <TendintaRentabilitatiiFinanciare
                        bilanturiDesc={this.props.bilanturiDesc}
                    />

                </Grid>

                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span style={{ fontSize: 12 }}> {this.dictionary.financiar.rataRentabilitatiiFinanciareText}</span>

                   
                </Grid>


            </Grid>
        );
    }
}